import React, { useEffect, useState, useRef } from 'react';
import { Button, Checkbox, Form } from 'antd';
import { Row, Col, Table } from 'reactstrap';
import { Radio, Modal, Input, message, notification } from 'antd';   // 
import { FaLock } from 'react-icons/fa6';
import style from '../../../Styles/TimeSheet.module.css';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import {
  getSettings,
  getUserLeave,
  getUsersTimesheet,
} from '../../../store/reducers/actionPermission';
import { toastWarn, toastSuccess, toastError } from '../../Toast/ToastComponent';
import { PERMISSION_VALUE } from '../../../constant/constant';
import AntdModalComp from '../../ReusableComponents/AntdModalComp';
import SampleModal from '../../Reports/SampleModal';
import dayjs from 'dayjs';
import { LeaveManagementView } from '../../LeaveMangmentComponent/LeaveManagementView';
import { useAuth } from '../../../Context/AuthContext';
import { TimeSheetApi } from '../../../Api/TimeSheetApi';  //
import { CgEnter } from 'react-icons/cg';
import { FiLogIn, FiLogOut, FiAlertTriangle, FiClock } from "react-icons/fi";
import { MdOutlineAccessTime } from "react-icons/md";
const LEAVE_LOG_STATUS = ['fullDay', 'halfDay'];
const ONE_BY_SIXTY = 0.0166666666666667;

const formatTime = (time) => {

  if (!time || time === "00:00") {
    return "00:00 AM";
  }

  const [hour, minute] = time.split(":");

  let hrs = parseInt(hour, 10);

  const ampm = hrs >= 12 ? "PM" : "AM";

  hrs = hrs % 12 || 12;

  return `${String(hrs).padStart(2, "0")}:${minute} ${ampm}`;
};

const formatHours = (time) => {

  if (!time) {
    return "00:00hrs";
  }

  // STRING FORMAT => "9h 47m"
  if (typeof time === "string") {

    const hrsMatch = time.match(/(\d+)h/);

    const minsMatch = time.match(/(\d+)m/);

    const hrs = hrsMatch
      ? hrsMatch[1]
      : "00";

    const mins = minsMatch
      ? minsMatch[1]
      : "00";

    return `${String(hrs).padStart(2, "0")}:${String(mins).padStart(2, "0")}hrs`;
  }

  // NUMBER FORMAT
  const totalMinutes =
    Math.round(Number(time) * 60);

  const hrs =
    Math.floor(totalMinutes / 60);

  const mins =
    totalMinutes % 60;

  return `${String(hrs).padStart(2, "0")}:${String(mins).padStart(2, "0")}hrs`;
};

// const getErrorMessage = (item) => {

//   const checkIn = item?.check_in;
//   const checkOut = item?.check_out;

//   const isCheckInMissing =
//     checkIn === null ||
//     checkIn === undefined ||
//     checkIn === "" ||
//     checkIn === "00:00";

//   const isCheckOutMissing =
//     checkOut === null ||
//     checkOut === undefined ||
//     checkOut === "" ||
//     checkOut === "00:00";

//   const manualHours = Number(item?.total_hours || 0);
//   const totalHoursFormatted = item?.total_hours_formatted || "0h 0m";
//   // manual -> minutes
//   const manualMinutes =
//     Math.round(manualHours * 60);
//   // "9h 47m" -> 9.78
//   const match = totalHoursFormatted.match(/(\d+)h\s*(\d+)m/);
//   // biometric -> minutes
//   const biometricMinutes = match
//     ? (Number(match[1]) * 60) +
//     Number(match[2])
//     : 0;

//   // DIFFERENCE
//   const difference =
//     Math.abs(manualMinutes - biometricMinutes);
//   const hasLeaveEntry = item?.timesheet_data?.some(
//     (data) =>
//       data?.project_name
//         ?.toLowerCase()
//         ?.includes("leave")
//   );
//   const hasAttendance =
//     !isCheckInMissing || !isCheckOutMissing;

//   const isSpecialEntry =
//     item?.is_biometric === false ||

//     item?.timesheet_data?.some(
//       (data) =>
//         ["weekend", "leave", "holiday"].includes(
//           data?.project_name?.toLowerCase()
//         )
//     );

//   if (isSpecialEntry) {
//     return "";
//   }
//   // BOTH EMPTY
//   if (isCheckInMissing && isCheckOutMissing) {
//     return "Warning: Biometric data not available";
//   }

//   // ONLY CHECK-IN EMPTY
//   else if (isCheckInMissing) {
//     return "Error: Missing check-in time";
//   }

//   // ONLY CHECK-OUT EMPTY
//   else if (isCheckOutMissing) {
//     return "Error: Missing check-out time";
//   }
//   // MANUAL VS BIOMETRIC CONFLICT
//   else if (difference > 15) {
//     return "Conflict: Manual and biometric times differ";
//   }
//   // HOURS LESS THAN 10
//   else if (totalHoursFormatted < 10) {
//     return "Shortage: Below required hours";
//   }

//   // LEAVE + ATTENDANCE CONFLICT
//   else if (hasLeaveEntry && hasAttendance) {
//     return "Leave conflict: Marked as leave but attendance detected";
//   }

//   return "";
// };

const HandleBadges = ({ item, approvalStatus, multiStatus }) => {
  const totalHoursFormatted = item?.total_hours_formatted || "0h 0m";

  const extraHours =
    item?.extra_hours_formatted || "0h 0m";

  const hideAttendance =
    item?.is_biometric === false ||

    item?.timesheet_data?.some(
      (data) =>
        ["weekend", "leave", "holiday"].includes(
          data?.project_name?.toLowerCase()
        )
    );

  // CHECK-IN CHECK-OUT ARRAY
  const isCheckInMissing =
    !item?.check_in || item?.check_in === "00:00";

  const isCheckOutMissing =
    !item?.check_out || item?.check_out === "00:00";

  const isBothMissing =
    isCheckInMissing && isCheckOutMissing;

  const isAnyMissing =
    isCheckInMissing || isCheckOutMissing;

  const attendanceDetails = [
    {
      label: "Check In",
      value: isCheckInMissing
        ? "--/--"
        : formatTime(item?.check_in),

      icon: (
        <FiLogIn
          style={{
            color: "#28a745",
            fontSize: "14px",
            marginRight: "4px",
          }}
        />
      ),
    },

    {
      label: "Check Out",
      value: isCheckOutMissing
        ? "--/--"
        : formatTime(item?.check_out),

      icon: (
        <FiLogOut
          style={{
            color: "#dc3545",
            fontSize: "14px",
            marginRight: "4px",
          }}
        />
      ),
    },

    {
      label: "Total",

      value: isAnyMissing
        ? "--/--"
        : formatHours(totalHoursFormatted),

      valueColor:
        isAnyMissing
          ? "#dc3545"
          : totalHoursFormatted < 10
            ? "#dc3545"
            : "#198754",


      extra:
        !isAnyMissing && extraHours > "0h 0m"
          ? {
            label: "Extra Hrs",
            value: formatHours(extraHours),
          }
          : null,

    },
  ];
  return (
    <>
      <span>
        <span
          className={`me-2 ${approvalStatus === null
            ? ''
            : approvalStatus
              ? 'statusSuccess'
              : 'text-danger'
            }`}
        >
          <b className={`${style.sizeforfont}`}>{item.date}</b>
        </span>
        {item.permission_status !== 'PENDING' &&
          item.leave_status !== 'PENDING' &&
          !item.isLocked && (
            <span>
              <span
                className={`me-md-2 ${approvalStatus === null
                  ? ''
                  : approvalStatus
                    ? 'statusSuccess'
                    : 'text-danger'
                  }`}
              >
                <b className={`${style.sizeforfont}`}>{item.day}</b>
              </span>
              <span
                className={`alert ms-2 ms-md-0 ${approvalStatus === null
                  ? 'alert-warning'
                  : approvalStatus
                    ? 'alert-success'
                    : 'alert-danger'
                  } mb-0 py-0 px-2 rounded-pill`}
              >
                {`${approvalStatus === null
                  ? 'Pending'
                  : approvalStatus
                    ? 'Approved'
                    : 'Rejected'
                  }`}
              </span>

              {multiStatus && (
                <>
                  {' '}
                  <span className="m-2 d-none d-md-inline ">
                    <small>
                      <i>{multiStatus} by First Approver</i>
                    </small>
                  </span>
                  <div className="d-md-none ">
                    <small>
                      <i>{multiStatus} by First Approver</i>
                    </small>
                  </div>
                </>
              )}
            </span>
          )}


      </span>
      {item.leave_status == 'PENDING' && (
        <span style={{ color: '#b76d21' }} className="m-2">
          <i>This leave request has not been approved yet.</i>
        </span>
      )}
      {item.permission_status == 'PENDING' && (
        <span style={{ color: '#b76d21' }} className="m-2">
          <i>This Permission request has not been approved yet.</i>
        </span>
      )}
    </>
  );
}

let modalHeader = {};
let modalData = {};
function UserTimeSheetAccrdn({
  timeLog,
  handleClick,
  getAttendanceReport,
  handleUpdate,
  getLogsList,
}) {
  const navigate = useNavigate();
  const { authState } = useAuth();

  const { edit_id } = useParams();
  const [modal, setModal] = useState(false);

  const [leaveModal, setLeaveModal] = useState({
    isOpen: false,
    id: null,
    isPermission: false,
  });

  const leavePermission = useSelector(getUserLeave);

  const [leaveButtons, setLeaveButtons] = useState({});

  const handleLeaveButtonPermission = () => {
    for (const element of leavePermission?.actions) {
      const keyName = element?.statename?.toLowerCase();
      setLeaveButtons((prevState) => ({
        ...prevState,
        [keyName]: element?.checked,
      }));
    }
  };

  const debounceTimeoutRef = useRef(null);

  const [timeLogArr, setTimeLogArr] = useState([]);
  const [rejectModalOpen, setRejectModalOpen] = useState(false);         //
  const [rejectReason, setRejectReason] = useState('');                  //
  const [selectedIndex, setSelectedIndex] = useState(null);              //
  let userData = JSON.parse(atob(edit_id));

  const SettingsData = useSelector(getSettings);

  const permissionsData = useSelector(getUsersTimesheet);

  const [buttonPermission, setButtonPermissions] = useState({});

  const handleButtonPermission = () => {
    if (!permissionsData?.checked) {
      navigate('/');
    }
    for (const element of permissionsData?.actions) {
      const keyName = element?.statename?.toLowerCase();
      setButtonPermissions((prevState) => ({
        ...prevState,
        [keyName]: element?.checked,
      }));
    }
  };

  const handleStatusChange = (e, indx) => {      //
    const value = e.target.value;

    if (value === false) {
      setSelectedIndex(indx);
      setRejectModalOpen(true);
      return;
    }
    handlePopUp(e, indx);
  };

  const handleRejectSubmit = async () => {      // full

    if (!rejectReason.trim()) {
      toastWarn('Please enter reason');
      return;
    }

    try {
      const item = timeLogArr[selectedIndex];

      await TimeSheetApi.sendRejectEmail({
        id: item.id,
        user_id: item.user_id,
        is_approved: false,
        reject_reason: rejectReason,
        timesheet_data: item.timesheet_data,
        total_hours: item.total_hours,
        total_billable_hours: item.total_billable_hours,
        total_nonBillable_hours: item.total_nonBillable_hours,
        isBillable: item.isBillable,
        approver_id: authState.id,
        userRoleID: authState.id,
        hasProjectFilter: false
      });

      toastSuccess('Timesheet rejected successfully');

      setRejectModalOpen(false);
      setRejectReason('');

      getLogsList();

    } catch (err) {
      toastError('Something went wrong');
      console.error(err);
    }
  };

  useEffect(() => {
    setTimeLogArr(timeLog);
    getAttendanceReport();
    if (permissionsData || leavePermission) {
      handleButtonPermission();
      handleLeaveButtonPermission();
    }
  }, [timeLog]);

  const convertTimeToOne = (timespentArr) => {
    let milliSec =
      dayjs(timespentArr[1]).valueOf() - dayjs(timespentArr[0]).valueOf();
    let calMints = milliSec / (1000 * 60);
    let mintsToRound =
      calMints * ONE_BY_SIXTY > 0 ? calMints * ONE_BY_SIXTY : 0;
    return mintsToRound || 0;
  };

  const calculatebillable = (item) => {
    let bill = 0,
      nonbill = 0;
    item.forEach((itm, indx) => {
      if (itm.billable === true && itm.consider_bill === 'bill') {
        // bill += Number(itm.individual_hours);
        bill += convertTimeToOne(itm?.time_spent);
        return;
      } else if (
        itm.billable === false &&
        itm.consider_bill === 'bill' &&
        itm.project_id !== 1
      ) {
        // nonbill += Number(itm.individual_hours);
        nonbill += convertTimeToOne(itm?.time_spent);
      }
    });
    return {
      total_nonBillable_hours: Number(nonbill.toFixed(2)) || 0,
      total_billable_hours: Number(bill.toFixed(2)) || 0,
    };
  };

  const removeNonBill = (arr) => {
    return arr.filter(
      (item) => item.consider_bill === 'bill' && item.project_id !== 1,
    );
  };

  const checkBillableAll = (items) => {
    let count = 0;
    let onlyBillArr = removeNonBill(items) || [];
    onlyBillArr.forEach((item) => {
      if (item?.billable) {
        ++count;
      }
    });
    return onlyBillArr?.length === count;
  };

  const billableUpdate = async (logData) => {
    if (debounceTimeoutRef.current) {
      clearTimeout(debounceTimeoutRef.current);
    }

    debounceTimeoutRef.current = setTimeout(() => {
      let approverTypeArray = [
        'is_approved',
        'second_approvers_status',
        'first_approvers_status',
      ];

      for (const key of approverTypeArray) {
        if (logData[key] == 'null') {
          logData[key] = null;
        }
      }

      handleUpdate(logData, 'NoPopUp');
    }, 800);
  };
  const handleBillable = async (e, arrIndx, tableIndx) => {
    let checkedState = e.target.checked;
    let newTimeLog = timeLogArr.map((item, index) => {
      if (index === arrIndx) {
        let senData = item?.timesheet_data?.map((timeData, indx) => {
          if (indx === tableIndx) {
            return { ...timeData, billable: checkedState };
          }
          return timeData;
        });
        let cal = calculatebillable(senData) || {};
        let newSpreditm = {
          ...item,
          ...cal,
          timesheet_data: senData,
          isBillable: checkBillableAll(senData),
          // first_approvers_status:item?.first_approvers_status ? 'null' : item.first_approvers_status,
          // second_approvers_status:item?.second_approvers_status ? 'null' : item.second_approvers_status,
        };
        // if (userData?.isFirstApprover === true) {
        //   newSpreditm['first_approvers_status'] = 'null';
        //   newSpreditm['is_approved'] = 'null';
        // } else if (userData?.isSecondApprover === true) {
        //   newSpreditm['second_approvers_status'] = 'null';
        //   newSpreditm['is_approved'] = 'null';
        // }

        billableUpdate(newSpreditm);

        return {
          ...newSpreditm,
        };
      }
      return item;
    });

    setTimeLogArr(newTimeLog);
  };
  const handleAllBillable = (e, arrIndx, type) => {
    let checkedState = e.target.checked;
    let newTimeLog = timeLogArr.map((item, index) => {
      if (index === arrIndx) {
        let senData = (item?.timesheet_data || []).map((timeData, indx) => {      //
          if (timeData.consider_bill === 'nonbill' || timeData.project_id === 1)
            return timeData;
          return {
            ...timeData,
            billable: checkedState,
          };
        });
        let cal = calculatebillable(senData) || {};
        let newSpreditm = {
          ...item,
          ...cal,
          isBillable: checkedState,
          timesheet_data: senData,
        };
        // if (userData?.isFirstApprover === true) {
        //   newSpreditm['first_approvers_status'] = 'null';
        //   newSpreditm['is_approved'] = 'null';
        // } else if (userData?.isSecondApprover === false) {
        //   newSpreditm['second_approvers_status'] = 'null';
        //   newSpreditm['is_approved'] = 'null';
        // }

        billableUpdate(newSpreditm);

        return newSpreditm;
      }
      return item;
    });
    setTimeLogArr(newTimeLog);
  };

  // const handleApprove = (e, arrIndx) => {
  //   debugger;
  //   let checkedState = e.target.value;
  //   let arrpoveitem = {};

  //   let newLogItem = new Promise((resolve, reject) => {
  //     timeLogArr.map(async (item, index) => {
  //       if (index === arrIndx) {
  //         let senData = item?.timesheet_data?.map((timeData, indx) => {
  //           if (!checkedState) {
  //             return { ...timeData, billable: checkedState };
  //           }
  //           return timeData;
  //         });
  //         let cal = calculatebillable(senData) || {};
  //         arrpoveitem = {
  //           ...item,
  //           ...cal,
  //           total_nonBillable_hours: !checkedState
  //             ? 0
  //             : item['total_nonBillable_hours'],
  //           timesheet_data: senData,
  //           isBillable: checkedState ? item['isBillable'] : checkedState,
  //           first_approvers_status: item['first_approvers_status']
  //             ? checkedState
  //             : item['first_approvers_status'],
  //           second_approvers_status: item['second_approvers_status']
  //             ? checkedState
  //             : item['second_approvers_status'],
  //           is_approved: checkedState,
  //         };
  //         resolve(arrpoveitem);
  //         return arrpoveitem;
  //       }
  //       return item;
  //     });
  //   });
  //   newLogItem
  //     .then((data) => {
  //       handleClick('update', arrpoveitem);
  //     })
  //     .catch((err) => console.log(err));
  // };

  const getApprovalStatus = (item, index) => {
    if (
      (item.first_approvers_status === true && item.is_approved === true) ||
      (item.second_approvers_status === true && item.is_approved === true)
    ) {
      return { approvalStatus: true };
    } else if (
      item.first_approvers_status === true &&
      item.is_approved === 'null'
    ) {
      return { approvalStatus: null, multiStatus: 'Approved' };
    } else if (
      item.first_approvers_status === false &&
      item.is_approved === 'null'
    ) {
      return { approvalStatus: false, multiStatus: 'Rejected' };
    } else if (
      item.first_approvers_status === 'null' &&
      userData?.isSecondApprover == true
    ) {
      return { approvalStatus: null, multiStatus: 'Pending' };
    } else if (
      (item.first_approvers_status === false && item.is_approved === false) ||
      (item.second_approvers_status === false && item.is_approved === false)
    ) {
      return { approvalStatus: false };
    } else {
      return { approvalStatus: null };
    }
  };

  const WEEKENDHOLIDAY = ['weekend', 'publicHoliday'];
  const LEAVESTATUS = ['leave'];
  const SHOW_MODIFIED = ['semiWorking', 'working'];

  const colorSetter = (item, logItem) => {
    let setColor = '';
    if (WEEKENDHOLIDAY.includes(item.type)) {
      setColor = 'holidayGreen';
    } else if (LEAVESTATUS.includes(item.type)) {
      setColor = 'leaveRed';
    } else if (logItem.project_id === PERMISSION_VALUE) {
      setColor = 'permission';
    } else if (
      logItem?.leave_duration === LEAVE_LOG_STATUS[0] ||
      logItem?.leave_duration === LEAVE_LOG_STATUS[1]
    ) {
      setColor = 'leaveRed';
    }
    return style[setColor];
  };

  const toggleModal = (type, value) => {
    if (value && type === 'Edit') {
      modalData = {
        title: 'new',
        id: value.id,
        status: value.status,
      };
    } else if (type === '') {
      modalData = {};
    }
    modalHeader = <span className="text-nowrap">{`${type} `}</span>;
    setModal(!modal);
  };

  const handlePopUp = async (e, arrIndx) => {
    let checkedState = e.target.value;
    let arrpoveitem = {};

    let newLogItem = new Promise((resolve) => {
      timeLogArr.map(async (item, index) => {
        if (index === arrIndx) {
          let senData = item?.timesheet_data?.map((timeData, indx) => {
            if (!checkedState) {
              return { ...timeData, billable: checkedState };
            }
            return timeData;
          });
          // let cal = calculatebillable(senData) || {};
          arrpoveitem = {
            ...item,
            // ...cal,
            total_nonBillable_hours: !checkedState
              ? 0
              : item['total_nonBillable_hours'],
            timesheet_data: senData,
            isBillable: checkedState ? item['isBillable'] : checkedState,
            first_approvers_status: item['first_approvers_status']
              ? checkedState
              : item['first_approvers_status'],
            second_approvers_status: item['second_approvers_status']
              ? checkedState
              : item['second_approvers_status'],
            is_approved: checkedState == 'null' ? null : checkedState,
          };
          resolve(arrpoveitem);
          return arrpoveitem;
        }
        return item;
      });
    });
    newLogItem
      .then((data) => {
        const calcBill = calculatebillable(arrpoveitem?.timesheet_data) || {};
        handleClick('update', { ...arrpoveitem, ...calcBill });
      })
      .catch((err) => console.log(err));
  };

  const leaveToggle = (id, isPermission) => {
    setLeaveModal((prev) => ({
      ...prev,
      isOpen: !leaveModal.isOpen,
      id: id ? id : null,
      isPermission: isPermission ? true : false,
    }));
    getLogsList();
  };

  return (
    <>
      {timeLogArr.map((item, indx) => {
        // const errorMessage = getErrorMessage(item);
        const { approvalStatus, multiStatus } = getApprovalStatus(item, indx);
        return (
          <div className={`mb-4 `} key={indx + 77}>
            <Row className="m-0 ">
              <Col md={12} className="py-0 px-0 header_bgcolor">
                <div
                  className={`d-md-flex  align-items-center  justify-content-between ${style.fortablesmall}`}
                >
                  <div className="  p-md-2 ">
                    <HandleBadges
                      item={item}
                      approvalStatus={approvalStatus}
                      multiStatus={multiStatus}
                    />{' '}
                    {/* <span>
                      <AntdModalComp
                        width="auto"
                        toggleModal={() => toggleModal('Add', null)}
                        modalOpen={modal}
                        modalHeader={modalHeader}
                        modalBody={
                          <SampleModal
                            modaldata={modalData}
                            setModal={setModal}
                            modal={modal}
                          />
                        }
                      />
                    </span> */}
                    {!!item?.isLocked && (
                      <Button
                        type="none"
                        htmlType="button"
                        disabled={userData?.employee_id == authState?.id}
                        icon={<FaLock />}
                        onClick={() => handleClick('unlock', item.id)}
                      ></Button>
                    )}
                  </div>

                  <div
                    className={`d-md-flex align-items-center justify-content-md-end ${style.flexsmall}`}
                  >
                    {item.permission_status !== 'PENDING' &&
                      item.leave_status !== 'PENDING' &&
                      !item.isLocked && (
                        <div>
                          <Form.Item className="mb-0">
                            <Radio.Group
                              value={
                                userData?.isFirstApprover
                                  ? item?.first_approvers_status
                                  : item?.is_approved
                              }
                              disabled={userData?.employee_id == authState?.id}
                              onChange={(e) => handleStatusChange(e, indx)}
                              // onChange={(e) => handleApprove(e, indx)}
                              className={`${style.radioColor}`}
                            >
                              <Radio
                                // disabled={
                                //   !SettingsData.isSingleApprover &&
                                //   userData?.isSecondApprover == true &&
                                //   (!item?.first_approvers_status ||
                                //     item?.first_approvers_status == 'null')
                                //     ? true
                                //     : false
                                // }
                                value={'null'}
                              >
                                {' '}
                                Pending{' '}
                              </Radio>
                              {buttonPermission?.approve && (
                                <Radio
                                  // disabled={
                                  //   !SettingsData.isSingleApprover &&
                                  //   userData?.isSecondApprover == true &&
                                  //   (!item?.first_approvers_status ||
                                  //     item?.first_approvers_status == 'null')
                                  //     ? true
                                  //     : false
                                  // }
                                  value={true}
                                >
                                  {' '}
                                  Approve{' '}
                                </Radio>
                              )}
                              {buttonPermission?.reject && (
                                <Radio
                                  // disabled={
                                  //   !SettingsData.isSingleApprover &&
                                  //   userData?.isSecondApprover == true &&
                                  //   (!item?.first_approvers_status ||
                                  //     item?.first_approvers_status == 'null')
                                  //     ? true
                                  //     : false
                                  // }
                                  value={false}
                                >
                                  {' '}
                                  Reject{' '}
                                </Radio>
                              )}
                              {/* <Radio value={"null"}> Pending </Radio> */}
                            </Radio.Group>
                          </Form.Item>
                        </div>
                      )}
                    {/* <div className="px-1 pb-1 tmPointer">
                      <FaLock />
                    </div> */}
                  </div>

                  {(item.leave_status == 'PENDING' ||
                    item.permission_status == 'PENDING') && (
                      <span>
                        <Button
                          disabled={userData?.employee_id == authState?.id}
                          style={{ borderColor: 'rgb(22, 54, 88)' }}
                          onClick={() =>
                            leaveToggle(
                              item?.leave_id
                                ? item?.leave_id
                                : item?.permission_id,
                              item?.permission_id ? true : false,
                            )
                          }
                          type="default"
                          size="medium"
                          htmlType="button"
                        >
                          Review Request
                        </Button>
                      </span>
                    )}
                </div>
                {/* 🔴 ERROR ROW (FULL WIDTH BELOW) */}
                {/* ERROR MESSAGE */}
                {/* {errorMessage && (
                  <div
                    style={{
                      background:
                        errorMessage.includes("Warning")
                          ? "#fff3cd"
                          : "#f8d7da",
                      color:
                        errorMessage.includes("Warning")
                          ? "#856404"
                          : "#842029",
                      padding: "8px 12px",
                      fontSize: "13px",
                      borderRadius: "4px",
                      marginTop: "8px",
                      fontWeight: 500,
                    }}
                  >
                    {errorMessage}
                  </div>
                )} */}
              </Col>
              <Col
                md={12}
                className={`px-0  ${item.permission_status == 'PENDING' ||
                  item.leave_status == 'PENDING' ||
                  !!item.isLocked
                  ? style.tableDisable
                  : ''
                  }`}
              >
                <div className="">
                  <Table responsive className={`mb-0`} bordered>
                    <thead>
                      <tr>
                        <td className="col-2 px-2 border-0">
                          <b>PROJECTS</b>
                        </td>
                        <td className="col-2 px-2 border-0">
                          <b>MODULES</b>
                        </td>
                        <td className="col-3 px-2 border-0">
                          <b>TASKS</b>
                        </td>
                        <td className="col-2 px-2 border-0">
                          <b>TIME SPENT</b>
                        </td>
                        <td className="col-auto text-center border-0 px-2">
                          <b>IN HRS</b>
                        </td>
                        <td className="col-auto text-center border-0 px-2">
                          <b>TOTAL</b>
                        </td>
                        <td className="col-auto text-center border-0 px-0">
                          {!LEAVESTATUS.includes(item?.type) &&
                            !WEEKENDHOLIDAY.includes(item?.type) &&
                            item.leave_status !== 'PENDING' &&
                            item.permission_status !== 'PENDING' &&
                            !item.isLocked && (
                              <Checkbox
                                disabled={!item?.is_approved}
                                className="p-0 m-0"
                                checked={item?.isBillable}
                                onChange={(e) =>
                                  handleAllBillable(e, indx, 'all')
                                }
                              >
                                <b>BILLABLE</b>
                              </Checkbox>
                            )}
                          {(item.permission_status == 'PENDING' ||
                            item.leave_status == 'PENDING' ||
                            !!item.isLocked) && <b>BILLABLE</b>}
                        </td>
                      </tr>
                    </thead>
                    <tbody>
                      {item?.timesheet_data?.length > 0 &&
                        item?.timesheet_data?.map((logItem, index) => (
                          <tr
                            key={index + 45}
                            className={colorSetter(item, logItem)}
                          >
                            <td title={logItem?.project_name}>
                              {logItem?.project_name}
                            </td>
                            <td title={logItem?.module_name}>
                              {logItem?.module_name}
                            </td>
                            <td title={logItem?.task}>
                              <div className="d-flex justify-content-between align-items-center">
                                <div className="text-wrap">{logItem?.task}</div>
                                <div
                                  className={`border rounded-pill ${Boolean(logItem?.billable)
                                    ? style.billable
                                    : style.nonBillable
                                    }`}
                                >
                                  B
                                </div>
                              </div>
                            </td>
                            <td>{logItem.timeShow}</td>
                            <td className="text-center">
                              {!WEEKENDHOLIDAY.includes(item?.type) &&
                                !LEAVESTATUS.includes(item?.type)
                                ? `${logItem.individual_hours ?? 0} hr`
                                : ''}
                              {/* {logItem.individual_hours} hr */}
                            </td>
                            {index === 0 && (
                              <td
                                className="align-middle text-center border"
                                rowSpan={100}
                              >
                                {!WEEKENDHOLIDAY.includes(item?.type) &&
                                  !LEAVESTATUS.includes(item?.type)
                                  ? `${item.total_hours ?? 0.0} hrs`
                                  : ''}
                                {/* {item.total_hours} hrs */}
                              </td>
                            )}

                            <td className="text-center px-0">
                              {logItem?.project_id !== 1 &&
                                logItem?.consider_bill === 'bill' && (
                                  <span>
                                    {item.leave_status !== 'PENDING' &&
                                      item.permission_status !== 'PENDING' &&
                                      !item.isLocked && (
                                        <Checkbox
                                          disabled={!item?.is_approved}
                                          key={index + 33}
                                          checked={Boolean(logItem?.billable)}
                                          onChange={(e) =>
                                            handleBillable(e, indx, index)
                                          }
                                          className="p-0 m-0"
                                        />
                                      )}
                                  </span>
                                )}
                            </td>
                          </tr>
                        ))}
                    </tbody>
                  </Table>
                </div>
              </Col>
              <Col md={12} className="px-0">
                <div
                  className="d-flex align-items-center justify-content-between"
                  style={{ minHeight: 32 }}
                >
                  {/* Left: Submitted / Modified */}
                  {SHOW_MODIFIED.includes(item?.type) ? (
                    <div
                      style={{
                        color: '#a39f9f',
                        fontWeight: 700,
                        fontStyle: 'italic',
                        fontSize: 12,
                      }}
                      className="ms-2 py-1"
                    >
                      <div className="mb-1">
                        Submitted:{' '}
                        <span style={{ color: '#777' }}>{item?.createdAt}</span>
                      </div>
                      <div>
                        Modified:{' '}
                        <span style={{ color: '#777' }}>{item?.updatedAt}</span>
                      </div>
                    </div>
                  ) : (
                    <div />
                  )}

                  {/* Right: Reject Reason Box */}
                  {approvalStatus === false &&
                    item?.reject_reason &&
                    (Array.isArray(item.reject_reason)
                      ? item.reject_reason.length > 0
                      : String(item.reject_reason).trim() !== '') && (
                      <div
                        style={{
                          backgroundColor: '#e6eef8',
                          padding: '6px 16px',
                          fontSize: 13,
                          color: '#333',
                          flex: '0 0 auto',
                          maxWidth: '60%',
                        }}
                      >
                        <b>Reason:</b>{' '}
                        {Array.isArray(item.reject_reason)
                          ? item.reject_reason.join(', ')
                          : item.reject_reason}
                      </div>
                    )}
                </div>
              </Col>
              <Col md={12} className="px-0 mt-2">
                <div className="row d-fec mx-0 justify-content-end">
                  <div className="col-md-3 pe-0 d-md-flex justify-content-end align-items-center">
                    <span className={`${style.sizeforfont}`}>
                      Total Hours (Entered)
                    </span>
                    <span className={`ms-2 ${style.sizefortotal}`}>
                      <span>
                        <b className="primaryColor">{item.total_hours}</b>
                      </span>
                      <span className="text-muted fw-bold ms-1">{'hrs'}</span>
                    </span>
                  </div>
                  <div className="col-md-3 pe-0 d-md-flex justify-content-end align-items-center">
                    <span className={`${style.sizeforfont}`}>
                      Billable Hours
                    </span>
                    <span className={` ms-2 ${style.sizefortotal}`}>
                      <span>
                        <b className="primaryColor">
                          {item?.total_billable_hours}
                        </b>
                      </span>
                      <span className="text-muted fw-bold ms-1">{'hrs'}</span>
                    </span>
                  </div>
                  <div className="col-md-3 pe-0 d-md-flex justify-content-end align-items-center">
                    <span className={`${style.sizeforfont}`}>
                      Non-Billable Hours
                    </span>
                    <span className={`ms-2 ${style.sizefortotal}`}>
                      <span>
                        <b className="primaryColor">
                          {item?.total_nonBillable_hours}
                        </b>
                      </span>
                      <span className="text-muted fw-bold ms-1">{'hrs'}</span>
                    </span>
                  </div>
                </div>
              </Col>
            </Row>
          </div>
        );
      })}
      <span>
        <AntdModalComp
          width="90%"
          toggleModal={leaveToggle}
          modalOpen={leaveModal?.isOpen}
          modalHeader={<></>}
          modalBody={
            <LeaveManagementView
              modalId={leaveModal?.id}
              modalUserType={'userRequest'}
              leaveToggle={leaveToggle}
              buttonPermissions={leaveButtons}
              isPermission={leaveModal?.isPermission}
            />
          }
          closable={true}
          maskClosable={true}
        />
      </span>

      <AntdModalComp
        width="40%"
        toggleModal={() => setRejectModalOpen(false)}
        modalOpen={rejectModalOpen}
        modalHeader={
          <div style={{ fontSize: 18, fontWeight: 600 }}>
            Reject Timesheet
          </div>
        }
        modalBody={
          <div style={{ display: 'flex', flexDirection: 'column', gap: 12, padding: 10 }}>

            <label style={{ fontWeight: 500 }}>
              Reason for Rejection <span style={{ color: 'red' }}>*</span>
            </label>

            <Input.TextArea
              rows={4}
              placeholder="Write the reason..."
              value={rejectReason}
              onChange={(e) => setRejectReason(e.target.value)}
              style={{ borderRadius: 6 }}
            />

            <span style={{ fontSize: 12, color: '#888' }}>
              This message will also be sent to the employee via email.
            </span>

            <div style={{ display: 'flex', justifyContent: 'center', gap: 10, marginTop: 25 }}>
              <Button
                onClick={() => setRejectModalOpen(false)}
                style={{ minWidth: 100 }}
              >
                Cancel
              </Button>

              <Button
                type="primary"
                style={{ minWidth: 100 }}
                onClick={handleRejectSubmit}
              >
                Submit
              </Button>
            </div>

          </div>
        }
        closable={true}
        maskClosable={true}
      />
    </>

  );
}
export default UserTimeSheetAccrdn;
